import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Pages
import HomePage from './pages/HomePage';
import BryllupperPage from './pages/BryllupperPage';
import CykelloebPage from './pages/CykelloebPage';
import EventsPage from './pages/EventsPage';
import FamiliefotograferingPage from './pages/FamiliefotograferingPage';
import BrandingPage from './pages/BrandingPage';
import OmLundeMediaPage from './pages/OmLundeMediaPage';
import StorytellingPage from './pages/StorytellingPage';
import KontaktPage from './pages/KontaktPage';
import NotFoundPage from './pages/NotFoundPage';
import ForbiddenPage from './pages/ForbiddenPage';

export default function App() {
  return (
    <div className="min-h-screen flex flex-col bg-[#0C0C0D] text-[#F3EFEA] antialiased selection:bg-[#B89B72]/30 selection:text-white">
      {/* Scroll Restoration */}
      <ScrollToTop />

      {/* Global Header */}
      <Header />

      {/* Main Content Area */}
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/bryllupper" element={<BryllupperPage />} />
          <Route path="/cykelloeb" element={<CykelloebPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/branding" element={<BrandingPage />} />
          <Route path="/familiefotografering" element={<FamiliefotograferingPage />} />
          <Route path="/storytelling" element={<StorytellingPage />} />
          <Route path="/om-lunde-media" element={<OmLundeMediaPage />} />
          <Route path="/kontakt" element={<KontaktPage />} />
          <Route path="/403" element={<ForbiddenPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </main>

      {/* Global Footer */}
      <Footer />
    </div>
  );
}
